import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScriptsRoutingModule } from './scripts-routing-module';
import { NavbarModule } from '../navbar/navbar.module';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingModule } from '../loading/loading.module';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { ScriptsComponent } from './scripts/scripts.component';
import { ScriptsFormComponent } from './scripts-form/scripts-form.component';

@NgModule({
  declarations: [ScriptsComponent, ScriptsFormComponent],
  imports: [
    CommonModule,
    ScriptsRoutingModule,
    NavbarModule,
    ToolbarModule,
    TranslateModule,
    LoadingModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatTableModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatMenuModule,
  ],
})
export class ScriptsModule {}
